export function cleanUtf8(input: string | null | undefined): string | null {
  return (
    input
      ?.replace(/���/g, "'") // Fix smart apostrophes
      ?.replace(/â��/g, "—") // Fix em dashes
      ?.replace(/â�¦/g, "…") ?? null // Fix ellipses
  );
  // Add more replacements as needed
}

/**
 *
 * @param dateString
 * @param forceLocalTZ If you don't want local timezones messing with dates (i.e.
 * 2025-08-01 should always be Aug 1 no matter what), set this to true.
 * @returns
 */
export function standardDateFormat(
  dateString: string | null | undefined,
  forceLocalTZ = true,
): string {
  if (!dateString) return "";

  const date = new Date(dateString + forceLocalTZ ? "T00:00:00" : "");
  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Formats a date string into "Month DD, YYYY" format (e.g., "January 13, 2025")
 * @param dateString - The date string to format
 * @param forceLocalTZ - If true, treats the date as local timezone to avoid timezone shifts
 * @returns Formatted date string or empty string if invalid
 */
export function standardFormatDateLong(
  dateString: string | null | undefined,
  forceLocalTZ = true,
): string {
  if (!dateString) return "";

  const date = new Date(dateString + (forceLocalTZ ? "T00:00:00" : ""));
  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Formats a date string into "Month DD" format (e.g., "January 13")
 * @param dateString - The date string to format
 * @param forceLocalTZ - If true, treats the date as local timezone to avoid timezone shifts
 * @returns Formatted date string or empty string if invalid
 */
export function standardFormatDateShort(
  dateString: string | null | undefined,
  forceLocalTZ = true,
): string {
  if (!dateString) return "";

  const date = new Date(dateString + (forceLocalTZ ? "T00:00:00" : ""));
  if (isNaN(date.getTime())) return dateString;

  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
  });
}

/**
 * Formats a date string into US date format "MM-DD-YYYY" (e.g., "01-13-2025")
 * @param dateString - The date string to format
 * @param forceLocalTZ - If true, treats the date as local timezone to avoid timezone shifts
 * @returns Formatted date string in MM-DD-YYYY format or empty string if invalid
 */
export function formatUSDateString(
  dateString: string | null | undefined,
  forceLocalTZ = true,
): string {
  if (!dateString) return "";

  const date = new Date(dateString + (forceLocalTZ ? "T00:00:00" : ""));
  if (isNaN(date.getTime())) return dateString;

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}
